import { mapState } from 'vuex';
import styled from 'vue-styled-components';
import { display } from 'styled-system';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   width: 20px;\n   margin: 0 0 0 20px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   margin: 0 20px 0 7px;\n   color: #6b5e51;\n   font-size: 18px;\n   line-height: 22px;\n   font-weight: 700;\n   white-space: nowrap;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n   align-items: flex-start;\n   margin: auto auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 4px 8px 4px 8px;\n   color: #fff;\n   font-weight: 400;\n   font-style: normal;\n   background: #007582;\n   border: 1px solid #fff;\n   text-align: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n   display: flex;\n   margin: 0 20px 0 0;\n   color: #6b5e51;\n   line-height: 24px;\n   font-size: 18px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   justify-content: flex-end;\n   flex: 1 1 auto;\n   align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   background: ", ";\n   box-shadow: 0 3px 5px rgba(182, 182, 182, 0.75);\n   box-shadow: 0 3px 5px rgba(0, 0, 0, 0.45);\n   justify-content: flex-end;\n   display: flex;\n   flex-direction: column;\n   position: relative;\n   overflow: hidden;\n   width: 100%;\n   transition: height 0.4s ease;\n\n   & .slide-enter-active,\n   & .slide-leave-active {\n      transition: all 0.4s ease-out 0.1s;\n      transform: translateX(0px);\n   }\n   & .slide-enter,\n   &.slide-leave-to {\n      transform: translateX(100%);\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Section = styled("section", {})(_templateObject(), function (props) {
  return props.theme.secondaryColor;
});
var Slider = styled.div(_templateObject2());
var Offer = styled("div", {
  display: {
    default: function _default() {
      return ["none", "none", "flex"];
    },
    type: [Number, String, Array]
  }
})(_templateObject3(), display);
var Button = styled("button", {})(_templateObject4());
var Phone = styled.div(_templateObject5());
var PhoneNumber = styled.div(_templateObject6());
var PhoneIcon = styled.img(_templateObject7());

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  computed: _extends({}, mapState("theme", ["theme"]), {}, mapState("viewport", ["breakpoint", "scroll"])),
  render: function render() {
    var h = arguments[0];
    var _this$copy = this.copy,
        phone = _this$copy.phone,
        offer = _this$copy.offer,
        button = _this$copy.button;
    var _this$theme = this.theme,
        primaryColor = _this$theme.primaryColor,
        fontSizes = _this$theme.fontSizes;
    var icon = phone.icon,
        number = phone.number;
    var url = icon.url,
        alt = icon.alt;
    var scrollThreshold = {
      xs: 324,
      sm: 324,
      md: 495,
      lg: 520,
      xl: 530
    };
    var sectionHeights = {
      xs: 30,
      sm: 30,
      md: 40,
      lg: 40,
      xl: 40
    };
    var fontSizeLookuo = {
      xs: 12,
      sm: 12,
      md: 16,
      lg: 16,
      xl: 16
    };
    var isMobile = this.breakpoint === "xs" || this.breakpoint === "sm";
    var isScrolled = this.scroll.y > scrollThreshold[this.breakpoint];

    if (isMobile || isScrolled) {
      var targetHeight = sectionHeights[this.breakpoint];
      var fontSize = fontSizeLookuo[this.breakpoint] + "px";
      var height = targetHeight + "px";
      return h(Section, {
        "style": {
          height: height
        }
      }, [h("Transition", {
        "attrs": {
          "appear": true,
          "name": "slide"
        }
      }, [h(Slider, [h(Offer, [offer]), h(Button, {
        "style": {
          fontSize: fontSize
        }
      }, [button]), h(PhoneIcon, {
        "attrs": {
          "src": url,
          "alt": alt
        }
      }), h(PhoneNumber, {
        "style": {
          fontSize: fontSize
        }
      }, [number])])])]);
    }

    return null;
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
